import { type FieldIndentifier, parseFieldIdentifier } from "@packages/lib";
import { useLiveQuery } from "dexie-react-hooks";
import { dexie } from "./db";

// TODO: deprecate this whole file. only use the sync functions.

export const useOptions = (field: FieldIndentifier) => {
	const { schemaName, tableName, fieldName } = parseFieldIdentifier(field);

	const uiField = useLiveQuery(
		() => dexie.uiFields.get({ schemaName: schemaName ?? "public", tableName, fieldName }),
		[schemaName, tableName, fieldName],
	);

	const optionList = useLiveQuery(
		() => (uiField?.optionGroupId ? dexie.options.where("optionGroupId").equals(uiField.optionGroupId).toArray() : []),
		[uiField?.optionGroupId],
	);

	if (!optionList) return {};

	return Object.fromEntries(optionList.map((option) => [option.id, option]));
};

export const useOptionLabel = (field: FieldIndentifier, optionId: string | null | undefined) => {
	const { schemaName, tableName, fieldName } = parseFieldIdentifier(field);

	const uiField = useLiveQuery(
		() => dexie.uiFields.get({ schemaName: schemaName ?? "public", tableName, fieldName }),
		[schemaName, tableName, fieldName],
	);

	const option = useLiveQuery(
		() =>
			uiField?.optionGroupId ? dexie.options.get({ optionGroupId: uiField.optionGroupId, id: optionId }) : undefined,
		[uiField?.optionGroupId, optionId],
	);

	if (!optionId || !option) return null;

	return option.labelSv || option.labelEn || optionId;
};
